import { useWorksheetSupplementaryLearning } from '~/@common/hooks/useWorksheetParentReport'

import { SupplementaryLearningCard } from './SupplementaryLearningCard'

type Props = {
  studentId?: string | null
  worksheetId?: number | null
}

export const WorksheetSupplementaryLearning = ({ studentId, worksheetId }: Props) => {
  const { data } = useWorksheetSupplementaryLearning(studentId, worksheetId)
  return <SupplementaryLearningCard data={data ?? []} />
}
